export default "__VITE_ASSET__Djw9BjyH__"